export function formatSize(sizeKb: number): string {
  if (sizeKb < 1024) {
    return `${Math.round(sizeKb)} KB`;
  }
  return `${(sizeKb / 1024).toFixed(1)} MB`;
}

export function formatDateTime(iso: string): string {
  const date = new Date(iso);
  const datePart = date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
  const timePart = date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
  });
  return `${datePart}, ${timePart}`;
}
